import styled from 'styled-components';

export default styled.div`
  font-size: 12px;
  line-height: 1.3;
  color: var(--dark-gray);

  p {
    margin: 0;
  }

  a {
    text-decoration: underline;
    color: inherit;
    text-underline-offset: 0.2em;
  }
`;